var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#85D1FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0041 30.5V28.6111C33.0041 26.8508 31.8002 25.3717 30.1708 24.9523M26.8652 13.7746C28.2497 14.335 29.2263 15.6923 29.2263 17.2778C29.2263 18.8632 28.2497 20.2205 26.8652 20.7809M28.2819 30.5C28.2819 28.7398 28.2819 27.8597 27.9943 27.1654C27.6109 26.2398 26.8755 25.5043 25.9498 25.1209C25.2556 24.8333 24.3755 24.8333 22.6152 24.8333H19.7819C18.0217 24.8333 17.1416 24.8333 16.4473 25.1209C15.5217 25.5043 14.7862 26.2398 14.4028 27.1654C14.1152 27.8597 14.1152 28.7398 14.1152 30.5M24.9763 17.2778C24.9763 19.3642 23.285 21.0556 21.1986 21.0556C19.1122 21.0556 17.4208 19.3642 17.4208 17.2778C17.4208 15.1914 19.1122 13.5 21.1986 13.5C23.285 13.5 24.9763 15.1914 24.9763 17.2778Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAbout);
export default __webpack_public_path__ + "static/media/active-about.a7ef1fac6da62ee7d638ff0c509842b1.svg";
export { ForwardRef as ReactComponent };